import {readLoginInstallation,writeLoginInstallation} from '../shared/login-installations.js';
import type {SessionVault} from './session-vault.ts';

type MetadataStore={read():Promise<string|null|undefined>;write(value:string):Promise<void>};

export function loginInstallationVault(platform:string,store:MetadataStore):Pick<SessionVault,'loadInstallation'|'saveInstallation'> {
 // Every web password login starts an independent session. localStorage is
 // shared by windows, and even sessionStorage can be copied when duplicating a
 // tab. Reusing either ID would rotate another window's credentials. Reloads
 // still resume the existing credential journal without a new password login.
 if(platform==='web')return {};
 // A native installation keeps its identity and notification registration.
 return {
  loadInstallation:async(address,email)=>readLoginInstallation(await store.read(),address,email),
  saveInstallation:async(address,email,id)=>store.write(writeLoginInstallation(await store.read(),address,email,id))
 };
}
